import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { Card, Collapse } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faEye, faHdd } from "@fortawesome/free-solid-svg-icons";
import filterTypes from "data/filter-types";
import findFilterValue from "helpers/find-filter-value";
import FilterItem from "views/lib/components/filter/filter-item";
import FilterHeader from "views/lib/components/filter/filter-header";
import {
  openCustomModal,
  closeCustomModal
} from "views/lib/components/modals";
import {
  getZoneFilters,
  getZoneTypes,
  addZone
} from "actions/zone/actions";

import CreateNewZone from "views/pages/zoning/create-new-zone";
import SelectFromTemplateZone from "views/pages/zoning/select-from-template-zone";
import ViewAllZones from "views/pages/zoning/view-all-zones";
import moment from "moment";

class ZoneFilers extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filters: {}
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleChangeFilter = this.handleChangeFilter.bind(this);

    this.props.getZoneFilters();
    this.props.getZoneTypes();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.totalCount !== this.props.totalCount) {
      return true;
    } else if (nextState.isOpen !== this.state.isOpen) {
      return true;
    } else if (!_.isEqual(nextState.filters, this.state.filters)) {
      return true;
    } else if (!_.isEqual(nextProps.activeFilters, this.props.activeFilters)) {
      return true;
    }
    return false;
  }

  handleSearch = () => {
    const { filters } = this.state;
    const filtersToArray = [];
    Object.keys(filters)
      .forEach(name => {
        if (Object.keys(filters[name]).length) {
          filtersToArray.push(filters[name]);
        }
      });
    this.props.handleSearch(filtersToArray);
  };

  handleReset = () => {
    this.setState({
      filters: {}
    }, this.props.handleReset);
  };

  handleChangeFilter = (name, valueObject) => {
    const { filters } = this.state;
    filters[name] = valueObject;
    this.setState({
      filters
    });
  };

  handleAddZone = () => {
    const modalObj = {
      modalSettings: {
        size: "md",
        style: {
          top: 20,
          width: "calc(100% - 40px)",
        }
      },
      header: "Add new Zone",
      children: (
        <CreateNewZone
          onCancel={() => this.props.closeCustomModal(modalObj)}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  handleViewAll = () => {
    const modalObj = {
      modalSettings: {
        size: "lg",
        style: {
          width: "calc(100% - 40px)",
        }
      },
      header: "View All Active Zones",
      children: (
        <ViewAllZones/>
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  handleAddFromTemplate = () => {
    const modalObj = {
      modalSettings: {
        size: "sm",
        style: {
          top: 20,
        }
      },
      header: "Add from template",
      children: (
        <SelectFromTemplateZone
          onCancel={() => this.props.closeCustomModal(modalObj)}
          onSubmit={zone => {
            delete zone.id;
            zone.template = false;
            zone.end = moment()
              .endOf("day")
              .valueOf();
            this.props.addZone(zone);
            this.props.closeCustomModal(modalObj);
          }}
        />
      ),
      handleClose: () => this.props.closeCustomModal(modalObj)
    };
    this.props.openCustomModal(modalObj);
  };

  render() {
    const {
      activeFilters,
      totalCount,
      zoneTypes
    } = this.props;
    const { isOpen } = this.state;

    return (
      <Card className="w-100 mb-2 rounded-0">
        <FilterHeader
          title={
            <div className="d-flex">
              <div>Zones</div>
              <div>
                <button
                  className="btn btn-sm btn-success ml-2"
                  onClick={this.handleAddZone}
                  title="Add new zone"
                >
                  <FontAwesomeIcon icon={faPlusSquare}/>
                </button>
                <button
                  className="btn btn-sm btn-primary ml-2"
                  onClick={this.handleAddFromTemplate}
                  title="Add from template"
                >
                  <FontAwesomeIcon icon={faHdd}/>
                </button>
                <button
                  className="btn btn-sm btn-warning ml-2"
                  onClick={this.handleViewAll}
                  title="View all active zones"
                >
                  <FontAwesomeIcon icon={faEye}/>
                </button>
              </div>
            </div>
          }
          totalCount={totalCount}
          isOpen={isOpen}
          onToggle={(status) => this.setState({ isOpen: status })}
        />
        <Card.Body className="p-0">
          <Collapse in={isOpen} className="p-3" timeout={0}>
            <div className="row">
              <div className="col-12 col-md-2 mb-3">
                <FilterItem
                  name="name"
                  placeholder="Name"
                  filterType="text"
                  defaultValue=""
                  onChange={this.handleChangeFilter}
                  searchOperation={[filterTypes.LIKE.value]}
                  value={findFilterValue("name", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-2 mb-3">
                <FilterItem
                  name="bonus"
                  placeholder="Bonus"
                  filterType="number"
                  onChange={(name, valueObject) => {
                    if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                      this.handleChangeFilter(name, {
                        ...valueObject,
                        fieldValue: parseFloat(valueObject.fieldValue)
                      });
                    } else {
                      this.handleChangeFilter(name, {});
                    }
                  }}
                  searchOperation={[
                    filterTypes.MORE.value,
                    filterTypes.LESS.value,
                    filterTypes.EQUALS.value
                  ]}
                  value={findFilterValue("bonus", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="radius"
                  placeholder="Radius"
                  filterType="number"
                  onChange={(name, valueObject) => {
                    if (typeof valueObject === "object" && Object.keys(valueObject).length) {
                      this.handleChangeFilter(name, {
                        ...valueObject,
                        fieldValue: parseFloat(valueObject.fieldValue)
                      });
                    } else {
                      this.handleChangeFilter(name, {});
                    }
                  }}
                  searchOperation={[
                    filterTypes.MORE.value,
                    filterTypes.LESS.value,
                    filterTypes.EQUALS.value
                  ]}
                  value={findFilterValue("radius", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-3 mb-3">
                <FilterItem
                  name="type"
                  placeholder="Zone Type"
                  filterType="select_multiple"
                  filterTypeOptions={zoneTypes.map(value => ({
                    label: value,
                    value
                  }))}
                  onChange={this.handleChangeFilter}
                  searchOperation={[filterTypes.IN.value]}
                  value={findFilterValue("type", activeFilters)}
                />
              </div>
              <div className="col-12 col-md-2 mb-3">
                <div className="d-flex justify-content-between justify-content-md-end">
                  <button
                    className="btn btn-warning btn-sm ml-2"
                    onClick={this.handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-success btn-sm ml-2"
                    onClick={this.handleSearch}
                  >
                    Load
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    );
  }
}

ZoneFilers.defaultProps = {
  activeFilters: []
};

ZoneFilers.propTypes = {
  activeFilters: PropTypes.array.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  zoneFilters: state.zone.zoneFilters,
  zoneTypes: state.zone.zoneTypes,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getZoneFilters: bindActionCreators(getZoneFilters, dispatch),
  getZoneTypes: bindActionCreators(getZoneTypes, dispatch),
  addZone: bindActionCreators(addZone, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ZoneFilers);



// WEBPACK FOOTER //
// ./src/views/pages/zoning/filters.js